import React from "react";

const Icon = () => {
  return (
    <svg
      id="https://www.flaticon.com/"
      enableBackground="new 0 0 512 512"
      height="80"
      viewBox="0 0 512 512"
      width="80"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="m462.049 455.805h-412.098c-27.587 0-49.951-22.364-49.951-49.951v-8.325c0-4.598 3.727-8.325 8.325-8.325h495.35c4.598 0 8.325 3.727 8.325 8.325v8.325c0 27.587-22.364 49.951-49.951 49.951z"
          fill="#a2aae2"
        />
        <path
          d="m495.35 389.203h-478.7v-312.195c0-11.495 9.318-20.813 20.813-20.813h437.073c11.495 0 20.813 9.318 20.813 20.813v312.195z"
          fill="#a2aae2"
        />
        <path
          d="m477.659 56.454v304.652c0 5.747-4.659 10.407-10.406 10.407h-450.603v17.691h478.7v-312.196c0-10.431-7.682-19.044-17.691-20.554z"
          fill="#8993da"
        />
        <path
          d="m49.951 345.601v-245.803c0-5.69 4.612-10.302 10.302-10.302h391.494c5.69 0 10.302 4.612 10.302 10.302v245.803c0 5.69-4.612 10.302-10.302 10.302h-391.494c-5.689 0-10.302-4.613-10.302-10.302z"
          fill="#d3effb"
        />
        <path
          d="m439.154 89.496v266.407h12.592c5.69 0 10.302-4.612 10.302-10.302v-245.803c0-5.69-4.612-10.302-10.302-10.302z"
          fill="#ff401a"
        />
        <path
          d="m503.675 389.203h-29.138c4.598 0 8.325 3.727 8.325 8.325v8.325c0 27.587-22.364 49.951-49.951 49.951h29.138c27.587 0 49.951-22.364 49.951-49.951v-8.325c0-4.597-3.727-8.325-8.325-8.325z"
          fill="#8993da"
        />
        <path
          d="m292.731 422.504h-73.462c-9.103 0-17.15-5.916-19.866-14.605l-5.842-18.696h124.878l-5.842 18.696c-2.716 8.689-10.763 14.605-19.866 14.605z"
          fill="#2b3890"
        />
        <path
          d="m391.285 321.561h-270.57c-5.747 0-10.407-4.659-10.407-10.406v-141.529h291.382v141.529c.001 5.747-4.658 10.406-10.405 10.406z"
          fill="#e28086"
        />
        <path
          d="m378.797 169.626v141.529c0 5.747-4.659 10.406-10.406 10.406h22.894c5.747 0 10.407-4.659 10.407-10.406v-141.529z"
          fill="#dd636e"
        />
        <path
          d="m391.285 123.837h-270.57c-5.747 0-10.407 4.659-10.407 10.407v35.382h291.382v-35.382c.001-5.748-4.658-10.407-10.405-10.407z"
          fill="#da4a54"
        />
        <path
          d="m391.285 123.837h-22.895c5.747 0 10.406 4.659 10.406 10.407v35.382h22.894v-35.382c.001-5.748-4.658-10.407-10.405-10.407z"
          fill="#d82e3d"
        />
        <g>
          <g>
            <path
              d="m161.727 287.527c0 5.003-4.056 9.059-9.059 9.059s-9.059-4.056-9.059-9.059 4.056-9.059 9.059-9.059 9.059 4.056 9.059 9.059z"
              fill="#2b3890"
            />
          </g>
        </g>
        <g>
          <path
            d="m368.39 210.653h-178.992c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h178.992c4.268 0 7.726 3.459 7.726 7.726s-3.458 7.726-7.726 7.726z"
            fill="#f4fbff"
          />
        </g>
        <g>
          <path
            d="m337.171 243.954h-147.773c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h147.773c4.268 0 7.726 3.459 7.726 7.726s-3.458 7.726-7.726 7.726z"
            fill="#f4fbff"
          />
        </g>
        <g>
          <path
            d="m212.293 295.254h-22.894c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h22.894c4.268 0 7.726 3.459 7.726 7.726s-3.459 7.726-7.726 7.726z"
            fill="#5766cb"
          />
        </g>
        <g>
          <path
            d="m368.39 295.254h-22.894c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h22.894c4.268 0 7.726 3.459 7.726 7.726s-3.458 7.726-7.726 7.726z"
            fill="#da4a54"
          />
        </g>
        <g>
          <g>
            <g>
              <path
                d="m152.801 261.494c-4.268 0-7.726-3.459-7.726-7.726v-50.841c0-4.268 3.459-7.726 7.726-7.726s7.726 3.459 7.726 7.726v50.841c0 4.267-3.459 7.726-7.726 7.726z"
                fill="#2b3890"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Icon;
